module.exports = new __parcel__URL__("apply_c_faq_expanded_en.cd868b3b.webp").toString();